import { useState, useEffect } from 'react';
import { IoClose } from "react-icons/io5";

export default function OutStationRatesModal({ isOpen, onClose, onSubmit, editData, zones = [] }) {
  const [formData, setFormData] = useState({
    zoneId: '',
    minWeight: '',
    maxWeight: '',
    builtyRate: '',
    coachRate: '',
    addaDelivery: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        zoneId: '',
        minWeight: '',
        maxWeight: '',
        builtyRate: '',
        coachRate: '',
        addaDelivery: ''
      });
      setErrors({});
    } else if (editData) {
      setFormData({
        zoneId: editData.zone_id || '',
        minWeight: editData.min_weight || '',
        maxWeight: editData.max_weight || '',
        builtyRate: editData.builty_rate || '',
        coachRate: editData.coach_rate || '',
        addaDelivery: editData.adda_delivery || ''
      });
      setErrors({});
    }
  }, [isOpen, editData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const regex = /^\d*\.?\d*$/;
    if (regex.test(value) || value === '') {
      setFormData(prev => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.zoneId) {
      newErrors.zoneId = 'Zone selection is required';
    }

    if (!formData.minWeight) {
      newErrors.minWeight = 'Minimum Weight is required';
    }

    if (!formData.maxWeight) {
      newErrors.maxWeight = 'Maximum Weight is required';
    }

    if (formData.minWeight && formData.maxWeight) {
      const min = parseFloat(formData.minWeight);
      const max = parseFloat(formData.maxWeight);
      if (min >= max) {
        newErrors.maxWeight = 'Maximum Weight must be greater than Minimum Weight';
      }
    }

    if (!formData.builtyRate) {
      newErrors.builtyRate = 'Builty Rate is required';
    }

    if (!formData.coachRate) {
      newErrors.coachRate = 'Coach Rate is required';
    }

    if (!formData.addaDelivery) {
      newErrors.addaDelivery = 'Adda Delivery is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const submitData = {
        zone_id: formData.zoneId,
        min_weight: parseFloat(formData.minWeight),
        max_weight: parseFloat(formData.maxWeight),
        builty_rate: parseFloat(formData.builtyRate),
        coach_rate: parseFloat(formData.coachRate),
        adda_delivery: parseFloat(formData.addaDelivery)
      };
      onSubmit(submitData);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-800">
            {editData ? "Edit Out-Station Base Rate" : "Add Out-Station Base Rate"}
          </h2>
          <button
            className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
            onClick={onClose}
          >
            <IoClose className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Out Station Zone Name <span className="text-red-500">*</span>
            </label>
            <select
              name="zoneId"
              value={formData.zoneId}
              onChange={handleInputChange}
              disabled={editData ? true : false}
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.zoneId ? 'border-red-500' : 'border-gray-300'
                } ${editData ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            >
              <option value="">Select a zone</option>
              {zones.map((zone) => (
                <option key={zone.id} value={zone.id}>{zone.zone_name}</option>
              ))}
            </select>
            {errors.zoneId && (
              <p className="text-red-500 text-sm mt-1">{errors.zoneId}</p>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Minimum Weight
              </label>
              <input
                type="text"
                name="minWeight"
                value={formData.minWeight}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.minWeight ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="e.g., 1, 2, 3.4"
              />
              {errors.minWeight && (
                <p className="text-red-500 text-sm mt-1">{errors.minWeight}</p>
              )}
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Maximum Weight
              </label>
              <input
                type="text"
                name="maxWeight"
                value={formData.maxWeight}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.maxWeight ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="e.g., 1, 2, 3.4"
              />
              {errors.maxWeight && (
                <p className="text-red-500 text-sm mt-1">{errors.maxWeight}</p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Builty Rate
              </label>
              <input
                type="text"
                name="builtyRate"
                value={formData.builtyRate}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.builtyRate ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="e.g., 1, 2, 3.4"
              />
              {errors.builtyRate && (
                <p className="text-red-500 text-sm mt-1">{errors.builtyRate}</p>
              )}
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Coach Rate
              </label>
              <input
                type="text"
                name="coachRate"
                value={formData.coachRate}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.coachRate ? 'border-red-500' : 'border-gray-300'
                  }`}
                placeholder="e.g., 1, 2, 3.4"
              />
              {errors.coachRate && (
                <p className="text-red-500 text-sm mt-1">{errors.coachRate}</p>
              )}
            </div>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Adda Delivery
            </label>
            <input
              type="text"
              name="addaDelivery"
              value={formData.addaDelivery}
              onChange={handleInputChange}
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.addaDelivery ? 'border-red-500' : 'border-gray-300'
                }`}
              placeholder="e.g., 1, 2, 3.4"
            />
            {errors.addaDelivery && (
              <p className="text-red-500 text-sm mt-1">{errors.addaDelivery}</p>
            )}
          </div>


          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              {editData ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}